import _ from 'lodash';
import { useState, useEffect, useContext } from 'react';
import { runPropTypes } from 'common/propTypes';
import {
  getDisplayTransactions
} from 'common/utils/transactionProfitHelper';
import { OrderContext } from 'ui/run/RunShow/OrderStore/index';
import withErrorBoundary from 'common/components/withErrorBoundary/index';
import { RUN_TYPES } from 'common/constants/index';
import LiveTransactionDetails from 'ui/run/RunShow/components/LiveDetails/LiveTransactionDetails/index';
import PropTypes from 'prop-types';
import TransactionsList from './components/TransactionsList/index';
import Header from './components/Header/index';
import TransactionsFooter from './components/TransactionsFooter';
import DeployLiveRun from 'v2/ui/run/RunShow/DeployLiveRun/index';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const propTypes = { run: runPropTypes.isRequired, isAccordianOpen: PropTypes.bool };

const defaultProps = { isAccordianOpen: true };
const INITIAL_PAGE_NO = 0;
const TRANSACTIONS_PER_PAGE = 10;

const TransactionTable = (props) => {
  const {
    run: {
      id, run_type: runType, display_name: displayName, order_type: orderType, granularity, status
    }, isAccordianOpen
  } = props;
  const { transactions, isLoading, filterConfigs, currentUser } = useContext(OrderContext);
  const { live } = RUN_TYPES;
  const isLive = runType === live;

  if (isLoading && !transactions.length) return null;

  const reverseTransactions = _.flatten(transactions.concat([])).reverse();
  // if reverse() the transactions all reference is also changed

  const [currentPageIndex, setCurrentPageIndex] = useState(INITIAL_PAGE_NO);
  const [transactionsPerPage, setTransactionsPerPage] = useState(TRANSACTIONS_PER_PAGE);
  const [filteredTransactions, setFilteredTransactions] = useState([]);
  const transactionsToDisplay = getDisplayTransactions(
    filteredTransactions, currentPageIndex, transactionsPerPage
  );

  useEffect(() => {
    setCurrentPageIndex(INITIAL_PAGE_NO);
  }, [JSON.stringify(_.omit(filterConfigs, ['slippageConfig']))]);

  const onFilterChange = (newTransactions) => {
    setFilteredTransactions(newTransactions);
    setCurrentPageIndex(INITIAL_PAGE_NO);
  };

  const onTransactionsPerPageChange = (newCount) => {
    setTransactionsPerPage(newCount);
    setCurrentPageIndex(INITIAL_PAGE_NO);
  };

  useEffect(() => {
    setFilteredTransactions(reverseTransactions);
  }, [transactions]);

  if (_.isEmpty(transactions) && !isLoading) {
    window.prerenderReady = true; // for share // this for empty Transactions
  }

  if (_.isEmpty(transactions)) return null;

  const renderTransactionList = () => {
    const isEmptyTransactionsToDisplay = _.isEmpty(transactionsToDisplay);

    if (isEmptyTransactionsToDisplay) { // empty transaction
      return (
        <div className="text-center mt-5">
          <img className="no-data-found" src="/no-data.svg" alt="No Data Found" />
        </div>
      );
    }

    if (window.innerWidth <= 991 && isLive) {
      return (
        <div className="live-transactions card-body px-0 pt-0">
        <Header
          onFilterChange={onFilterChange}
          runName={displayName}
          runId={id}
          onTransactionsPerPageChange={onTransactionsPerPageChange}
        />
          <LiveTransactionDetails
            transactions={transactionsToDisplay}
            runId={id}
            orderType={orderType}
            isAccordianOpen={isAccordianOpen}
            runStatus={status}
          />
        </div>
      );
    }

    return (
      <>
        <Header
          onFilterChange={onFilterChange}
          runName={displayName}
          runId={id}
          onTransactionsPerPageChange={onTransactionsPerPageChange}
        />
        <TransactionsList
          transactions={transactionsToDisplay}
          runId={id}
          isLive={isLive}
          orderType={orderType}
          granularity={granularity}
          runStatus={status}
        />
      </>
    );
  };

  const isRunBelongsToUser = currentUser?.id === props.run?.user_id;
  const showDeployBtn = ApplicationDomainUtility.isAlgoverse && currentUser && isRunBelongsToUser;

  return (
    <>
      <div className="card-header justify-content-sm-between flex-wrap gap-5">
        <div className="card-title d-flex justify-content-between align-items-center gap-3 w-100">
          <div>Transaction order details</div>
        <div className="io-btn-legend  align-items-center justify-content-evenly d-none">
      <div className="text-center d-flex align-items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="20px"
          viewBox="0 -960 960 960"
          width="24px"
          fill="#295F98"
        >
          <path d="M120-120v-80l80-80v160h-80Zm160 0v-240l80-80v320h-80Zm160
            0v-320l80 81v239h-80Zm160 0v-239l80-80v319h-80Zm160 0v-400l80-80v480h-80ZM120-327v-113l280-280
            160 160 280-280v113L560-447 400-607 120-327Z"
          />
        </svg>
        <p className="text-premium-chart px-1 mb-0">Premium Chart</p>
      </div>

      <div className="text-center d-flex align-items-center px-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="19px"
          viewBox="0 -960 960 960"
          width="20px"
          fill="#0091ae"
        >
          <path d="m296-80-56-56 276-277 140 140 207-207 57 57-264 263-140-140L296-80Zm-136-40q-33
            0-56.5-23.5T80-200v-560q0-33 23.5-56.5T160-840h560q33 0 56.5
            23.5T800-760v168H160v472Zm0-552h560v-88H160v88Zm0 0v-88 88Z"
          />
        </svg>
        <p className="text-option-chain px-1 mb-0">OptionChain</p>
      </div>
    </div>
        </div>
      </div>

      <div className="transaction-table card-body">
        {renderTransactionList()}
        <TransactionsFooter
          transactions={filteredTransactions}
          currentPageIndex={currentPageIndex}
          onCurrentPageChange={setCurrentPageIndex}
          transactionsPerPage={transactionsPerPage}
          deployLiveRun={showDeployBtn && (
            <DeployLiveRun
              run={props.run}
              currentUser={currentUser}
              currentUserDefaultFolderId={currentUser?.default_folder_id}
              isRunBelongsToUser={isRunBelongsToUser}
              shouldRenderDeployBtn={isRunBelongsToUser}
            />
          )}
        />
      </div>
    </>
  );
};

TransactionTable.propTypes = propTypes;
TransactionTable.defaultProps = defaultProps;

export default withErrorBoundary(TransactionTable);
